import { Divider, Typography } from '../../../designComponents';
import { TaskCardStyled } from './style';
import TaskCard from './TaskCard';
import { draftsManData, fireTeamData, taskDetailsData } from './taskData';
import TaskDetailsCard from './TaskDetailsCard';

const Tasks = () => {
  return (
    <>
      {fireTeamData.map((item, idx) => (
        <TaskCard key={idx} {...item} />
      ))}
      <Divider />
      {draftsManData.map((item, idx) => (
        <TaskCard key={idx} {...item} />
      ))}
      <Divider />
      <TaskCardStyled>
        <Typography fontColor="secondary" variant="title" strong>
          Task Details
        </Typography>
        {taskDetailsData.map((item, idx) => (
          <TaskDetailsCard key={idx} {...item} />
        ))}
      </TaskCardStyled>
    </>
  );
};

export default Tasks;
